"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.templateStr = exports.selectTemplate = exports.shouldUpdateTemplate = void 0;
const either_1 = require("./../../types/either");
const shouldUpdateTemplate = (productOption, nameSchema) => {
  let shouldUpdateTemplate = false;
  const keys = Object.keys(productOption);
  keys.forEach(key => {
    if (nameSchema.includes(key)) {
      shouldUpdateTemplate = true;
    }
  });
  return shouldUpdateTemplate;
};
exports.shouldUpdateTemplate = shouldUpdateTemplate;
const selectTemplate = (options, artObject) => {
  const templateId = (0, exports.templateStr)(options, (artObject === null || artObject === void 0 ? void 0 : artObject.nameScheme) || '');
  const template = artObject === null || artObject === void 0 ? void 0 : artObject.templates[templateId];
  if (!template) {
    const stringifiedOptions = Object.keys(options).map(attr => `${attr}: ${options[attr]}`).join(', ');
    const availableTemplateList = Object.keys((artObject === null || artObject === void 0 ? void 0 : artObject.templates) || {}).map(template => `${template}`).join(', ');
    return (0, either_1.left)(new Error(`Cannot find template with provided options: ${stringifiedOptions}. Available templates: ${availableTemplateList}`));
  }
  return (0, either_1.right)({
    templateId,
    template
  });
};
exports.selectTemplate = selectTemplate;
const templateStr = (options, str) => options ? str.replace(/\{(.*?)\}/g, match => {
  const attr = match.replace(/[{}]/g, '');
  return options[attr];
}) : str;
exports.templateStr = templateStr;